import {
  Listing,
  IListing,
} from '@app/models/Listing'
import { actionCreators, IListingSelectorState } from '../modules/listingSelector'
import { bindFunctions } from '@app/utils/class'
import { formatAddressSingleLine } from '@app/utils/formatting'
import * as React from 'react'
import Select, { ActionMeta, SingleValue } from 'react-select'
import { FilterOptionOption } from 'react-select/dist/declarations/src/filters'

interface IListingSelectorProps {
  className?: string
  name?: string
  onChange: (newValue: Listing | undefined) => void
  placeholder?: string
  required?: boolean
  isDisabled?: boolean
  invalid?: boolean
  value: IListing | undefined
  filterPropertyId?: string // Only show listings for this AssociatedProperty
}

type ListingSelectorProps = IListingSelectorProps &
  IListingSelectorState &
  typeof actionCreators

export class ListingSelector extends React.PureComponent<
  ListingSelectorProps
> {
  private selectRef: React.RefObject<HTMLDivElement>

  constructor(props: ListingSelectorProps) {
    super(props)
    this.selectRef = React.createRef()
    bindFunctions(this)
  }

  public componentDidMount() {
    this.props.loadListings(this.props.filterPropertyId)
    this._checkValidity()
  }

  public componentDidUpdate(prevProps: ListingSelectorProps) {
    if (prevProps.filterPropertyId !== this.props.filterPropertyId) {
      console.log('ListingSelector componentDidUpdate', this.props.filterPropertyId, prevProps.filterPropertyId)
      this.props.loadListings(this.props.filterPropertyId)
    }
    this._checkValidity()
  }

  public render() {
    return (
      <div ref={this.selectRef} className={this.props.className}>
        <Select
          key={this.props.value?.id ?? 'default'}
          filterOption={this._filterOption}
          onChange={this._onChange}
          formatOptionLabel={this._renderListingOptions}
          options={this.props.listings.toArray()}
          placeholder={this.props.placeholder || 'Select listing...'}
          required={this.props.required}
          loadingMessage={() => this.props.isLoading ? 'Loading listings...' : undefined}
          isDisabled={this.props.isDisabled}
          value={this.props.value}
          isLoading={this.props.isLoading}
          getOptionValue={(opt) => opt.id}
          getOptionLabel={(opt) => opt.title}
        />
      </div>
    )
  }

  private _checkValidity() {
    if (this.selectRef.current) {
      const inputElem = this.selectRef.current.querySelector('input:invalid')
      if (inputElem) {
        this.selectRef.current.classList.add('invalid')
      } else {
        this.selectRef.current.classList.remove('invalid')
      }
    }
  }

  private _filterOption(
    option: FilterOptionOption<IListing>,
    filter: string,
  ): boolean {
    const lOption = option || undefined
    const lFilter = filter.toLowerCase()

    return (
      lOption !== undefined &&
      (lOption.value.toLowerCase().indexOf(lFilter) >= 0 ||
        lOption.label.toLowerCase().indexOf(lFilter) >= 0 ||
        lOption.data.associatedProperty?.address.line1.toLowerCase().indexOf(lFilter) >= 0 ||
        lOption.data.associatedProperty?.address.line2.toLowerCase().indexOf(lFilter) >= 0 ||
        lOption.data.associatedProperty?.address.city.toLowerCase().indexOf(lFilter) >= 0)
    )
  }

  private _onChange(
    newValue: SingleValue<IListing>,
    actionMeta: ActionMeta<IListing>,
  ) {
    this.props.onChange((newValue as Listing) || undefined)
  }

  private _renderListingOptions(option: IListing) {
    return (
      <div>
        <div>
          <div>{option.title || option.associatedProperty.name}</div>
        </div>
        <div>
          <div className='small text-muted'>
            {option.associatedProperty?.address ? formatAddressSingleLine(option.associatedProperty.address) : ''}
          </div>
        </div>
      </div>
    )
  }
}
